<template>
  <v-navigation-drawer
    v-model="formShow"
    clipped
    right
    fixed
    width="30rem"
    style="top: 100px"
    stateless
  >
    <v-form
      ref="form"
      lazy-validation
      class="d-flex flex-column"
      style="height: calc(100% - 100px)"
    >
      <v-toolbar flat dark color="primary">
        <v-btn icon @click="handleBack">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <v-list-item>
          <v-list-item-title>เพิ่มสถานที่ใหม่</v-list-item-title>
        </v-list-item>
      </v-toolbar>
      <div class="pa-5" style="height: 100%; overflow: auto">
        <label class="body-2">
          ชื่อสถานที่
          <span class="red--text"><strong>*</strong></span>
        </label>
        <v-text-field
          class="fix-google-chrome mt-1"
          tabindex="1"
          v-model="location.title_th"
          :rules="[(v) => !!v || 'โปรดระบุชื่อสถานที่']"
          required
          clearable
          @change="checkEmpty($event, 'title_th')"
          outlined
          dense
        >
        </v-text-field>
        <label class="body-2"> ชื่อสถานที่ (อังกฤษ) </label>
        <v-text-field
          class="fix-google-chrome mt-1"
          tabindex="2"
          v-model="location.title_en"
          clearable
          @change="checkEmpty($event, 'title_en')"
          outlined
          dense
        ></v-text-field>
        <label class="body-2">
          ละติจูด
          <span class="red--text"><strong>*</strong></span>
        </label>
        <v-text-field
          class="fix-google-chrome mt-1"
          tabindex="3"
          v-model="location.latitude"
          :rules="[
            (v) =>
              !v || /^-?[0-9]*\.?[0-9]*$/.test(v) || 'ละติจูดต้องเป็นตัวเลข',
            (v) => !!v || 'จำเป็นต้องใส่ ละติจูด',
          ]"
          required
          clearable
          @click:clear="$store.commit('googleMap/SET_MARKERS', [])"
          @change="checkEmpty($event, 'latitude')"
          outlined
          dense
        >
        </v-text-field>
        <label class="body-2">
          ลองจิจูด
          <span class="red--text"><strong>*</strong></span>
        </label>
        <v-text-field
          class="fix-google-chrome mt-1"
          tabindex="4"
          v-model="location.longitude"
          :rules="[
            (v) =>
              !v || /^-?[0-9]*\.?[0-9]*$/.test(v) || 'ลองจิจูดต้องเป็นตัวเลข',
            (v) => !!v || 'จำเป็นต้องใส่ ลองจิจูด',
          ]"
          required
          clearable
          @click:clear="$store.commit('googleMap/SET_MARKERS', [])"
          @change="checkEmpty($event, 'longitude')"
          outlined
          dense
        >
        </v-text-field>
        <a v-if="appMode === 'private'" :href="googleMapsUrl" target="_blank">
          Google Maps
        </a>
        <v-btn
          v-else
          outlined
          color="error"
          @click="onOpenLocationGoogleMapDialog"
        >
          <v-icon>mdi-map-marker</v-icon>
        </v-btn>
        <div class="mt-4">
          <label class="body-2">
            Timezone
            <span class="red--text"><strong>*</strong></span>
          </label>
          <v-autocomplete
            class="fix-google-chrome mt-1"
            tabindex="5"
            v-model="location.timezone"
            :items="timezone"
            :rules="[(v) => !!v || 'โปรดระบุ Timezone']"
            item-text="text"
            item-value="adjustment"
            outlined
            dense
          >
          </v-autocomplete>
        </div>
      </div>
      <v-toolbar flat color="blue-grey lighten-4">
        <v-row justify="center" align="center">
          <v-btn tabindex="6" class="primary mr-3" depressed @click="onSubmit">
            เพิ่มสถานที่
          </v-btn>
          <v-btn depressed @click="onCancel">ยกเลิก</v-btn>
        </v-row>
      </v-toolbar>
    </v-form>
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
    <GoogleMap
      :dialog="googleMapDialog"
      @onSubmit="onSubmitLocationGoogleMapDialog"
      @onCancel="onCancelLocationGoogleMapDialog"
    />
  </v-navigation-drawer>
</template>

<script>
import axios from 'axios'
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import GoogleMap from '@/components/GoogleMap.vue'

// import static data
import timezone from '@/data/timezone.json'

export default {
  components: {
    ConfirmDialog,
    GoogleMap,
  },
  props: {
    formShow: {
      type: Boolean,
      default: false,
    },
    location: {
      type: Object,
    },
    locationInit: {
      type: Object,
    },
  },
  data() {
    return {
      timezone: timezone,
      googleMapDialog: false,
      googleMapsUrl: 'https://maps.google.com',
      appMode: process.env.VUE_APP_MODE,
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
    }
  },
  computed: {
    isTimeAttendanceLocationAddDataChange() {
      if (
        this.location.title_th !== this.locationInit.title_th ||
        this.location.title_en !== this.locationInit.title_en ||
        this.location.latitude !== this.locationInit.latitude ||
        this.location.longitude !== this.locationInit.longitude ||
        this.location.timezone !== this.locationInit.timezone
      ) {
        this.$emit('isTimeAttendanceLocationAddDataChange', true)
        return true
      }
      this.$emit('isTimeAttendanceLocationAddDataChange', false)
      return false
    },
    locationGoogleMap() {
      return this.markers.length > 0
        ? `${this.markers[0].position.lat.toFixed(
            5
          )}, ${this.markers[0].position.lng.toFixed(5)}`
        : ''
    },
    markers() {
      return this.$store.state.googleMap.markers
    },
    markersInit() {
      return this.$store.state.googleMap.markersInit
    },
  },
  methods: {
    ...mapActions({
      addOffSiteLocation: 'offSiteLocation/addOffSiteLocation',
    }),
    checkEmpty(value, field) {
      if (value) {
        this.location[field] = value.trim()
      }
    },
    onSubmit() {
      if (this.$refs.form.validate()) {
        this.$store.state.loading = true

        const newLocation = {
          title_th: this.location.title_th,
          title_en: this.location.title_en,
          latitude: this.location.latitude.toString(),
          longitude: this.location.longitude.toString(),
          timezone: this.location.timezone,
        }

        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          data: newLocation,
        }

        this.addOffSiteLocation(payload)
          .then(() => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'success',
              timeout: 2000,
              message: 'เพิ่มข้อมูลสำเร็จ',
            }

            this.$store.commit('SET_SNACKBAR', snackbar)

            this.$refs.form.resetValidation()
            this.$store.commit('googleMap/SET_MARKERS', [])
            this.$emit('addTimeAttendanceLocationAddSuccess')
          })
          .catch((error) => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          })
      }
    },
    onCancel() {
      this.$refs.form.resetValidation()
      this.$store.commit('googleMap/SET_MARKERS', [])
      this.$emit('addTimeAttendanceLocationAddSuccess')
    },
    handleBack() {
      if (this.isTimeAttendanceLocationAddDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
        }
        this.confirmDialogDataChange = true
      } else {
        this.$refs.form.resetValidation()
        this.$store.commit('googleMap/SET_MARKERS', [])
        this.$emit('addTimeAttendanceLocationAddSuccess')
      }
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
      this.$refs.form.resetValidation()
      this.$store.commit('googleMap/SET_MARKERS', [])
      this.$emit('addTimeAttendanceLocationAddSuccess')
    },
    onOpenLocationGoogleMapDialog() {
      if (this.location.latitude && this.location.longitude) {
        const markers = []
        const latLng = {
          lat: parseFloat(this.location.latitude),
          lng: parseFloat(this.location.longitude),
        }
        markers.push({ position: latLng })
        this.$store.commit('googleMap/SET_MAP_CENTER', latLng)
        this.$store.commit('googleMap/SET_MARKERS', markers)
      }
      this.googleMapDialog = true
    },
    onCloseLocationGoogleMapDialog() {
      this.googleMapDialog = false
    },
    onSubmitLocationGoogleMapDialog() {
      if (this.locationGoogleMap) {
        const location = this.locationGoogleMap.split(', ')
        const lat = location[0]
        const lng = location[1]

        this.location.latitude = lat
        this.location.longitude = lng

        // Current date/time of user computer
        const currentDate = new Date()
        // Current UTC date/time expressed as seconds since midnight, January 1, 1970 UTC
        const timestamp =
          currentDate.getTime() / 1000 + currentDate.getTimezoneOffset() * 60

        axios
          .get(
            `https://maps.googleapis.com/maps/api/timezone/json?location=${lat},${lng}&timestamp=${timestamp}&key=${process.env.VUE_APP_GOOGLE_MAP_API_KEY_CLIENT}`
          )
          .then((res) => {
            const result = res.data
            if (result.status !== 'ZERO_RESULTS') {
              const timezone = this.getTzString(result.rawOffset)
              const locationTimezone = this.timezone.find(
                (tz) => tz.adjustment === timezone
              )
              this.location.timezone = locationTimezone.adjustment
            }
            this.googleMapDialog = false
          })
      } else {
        this.googleMapDialog = false
      }
    },
    onCancelLocationGoogleMapDialog() {
      if (this.formAction === 'add') {
        this.$store.commit('googleMap/SET_MARKERS', [])

        this.location.latitude = ''
        this.location.longitude = ''
      } else {
        if (this.locationInit.latitude && this.locationInit.longitude) {
          const markers = []
          const latLng = {
            lat: parseFloat(this.locationInit.latitude),
            lng: parseFloat(this.locationInit.longitude),
          }
          markers.push({ position: latLng })
          this.$store.commit('googleMap/SET_MAP_CENTER', latLng)
          this.$store.commit('googleMap/SET_MARKERS', markers)
          this.location.latitude = this.locationInit.latitude
          this.location.longitude = this.locationInit.longitude
        } else {
          this.$store.commit('googleMap/SET_MARKERS', [])
        }
      }
      this.googleMapDialog = false
    },
    getTzString(offset) {
      const secInHour = 3600
      const secInMin = 60

      let isNagativeOffset = offset < 0
      let positiveOffset = Math.abs(offset)

      // hour
      let h = '' + Math.floor(positiveOffset / secInHour)
      while (h.length < 2) {
        h = '0' + h
      }
      if (isNagativeOffset) {
        h = '-' + h
      } else {
        h = '+' + h
      }

      // minute
      let m = ((positiveOffset % secInHour) / secInHour) * secInMin

      return `${h}:${m === 0 ? '00' : m}`
    },
  },
}
</script>
